import React from "react";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import extendedTablesStyle from "../../assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";
import ReactTable from "react-table";
import moment from "moment";
// Icons
//core components
import TextField from "@material-ui/core/TextField";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import Card from "../../components/Card/Card.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
// import CardIcon from "components/Card/CardIcon.jsx";
// import CardHeader from "components/Card/CardHeader.jsx";
// import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import Tooltip from "@material-ui/core/Tooltip";
import Switch from "@material-ui/core/Switch";
import green from "@material-ui/core/colors/green";
import DeleteModel from "../../components/Common/FevoModels/DeleteModel";
import { getCustomerData } from "../../actions/customerActions";
import toastr from "toastr";
import axios from "axios";
import { domain } from "../../utils/util";

class ManagePaidDeclaration extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      paidDeclaration: [],
    };
  }

  componentDidMount() {
    // this.props.fetchUsers()
    // this.props.getCustomerData();
    let data = JSON.parse(localStorage.getItem("BerPay_Admin"));
    let config = {};
    if (data) {
      config = {
        headers: { Authorization: `Bearer ${data.token}` },
      };
    }
    axios
      .get(`${domain}/declaration/notification/list?page=1&limit=100`, config)
      .then((res) => {
        if (res.data.statusCode === 200 || res.data.statusCode === 201) {
          let paidDeclaration = res.data.data.data;
          this.setState({
            paidDeclaration,
          });
        } else if (res && res.data && res.data.statusCode === 401) {
          localStorage.removeItem("BerPay_Admin");
          this.props.history.push("/admin/pages/login-page");
        }
      })
      .catch((error) => {});
  }

  handleChange = (event) => {
    this.setState({ ...this.state, [event.target.name]: event.target.checked });
  };

  getPaymentTableColumn = () => {
    const { classes } = this.props;
    const theme = createMuiTheme({
      palette: {
        primary: green,
      },
    });
    let self = this;
    let column = [
      {
        Header: "Actions",
        accessor: "actions",
        sortable: false,
        filterable: false,
        headerStyle: { textAlign: "center" },
        Cell: (props) => {
          return (
            <div className="actions-center">
              <Tooltip title="Accept">
                <IconButton
                  color="primary"
                  className={classes.button}
                  onClick={(e) => {
                    e.stopPropagation();
                    let declaration_id = props.original.action_id;
                    let body = {
                      declaration_id,
                      request_delete: "accept",
                    };
                    let data = JSON.parse(localStorage.getItem("BerPay_Admin"));
                    let config = {};
                    if (data) {
                      config = {
                        headers: { Authorization: `Bearer ${data.token}` },
                      };
                    }
                    axios
                      .put(`${domain}/declaration/update`, body, config)
                      .then((res) => {
                        if (
                          res.data.statusCode === 200 ||
                          res.data.statusCode === 201
                        ) {
                          toastr.success(
                            "Declaration Request Accepted Successfully!"
                          );
                          setTimeout(() => {
                            window.location.reload();
                          }, 2000);
                        } else if (res.data.statusCode === 401) {
                          localStorage.removeItem("BerPay_Admin");
                          this.props.history.push("/admin/pages/login-page");
                        }
                      })
                      .catch((error) => {});
                  }}
                >
                  <Icon>check</Icon>
                </IconButton>
              </Tooltip>
              <Tooltip title="Reject">
                <IconButton
                  color="primary"
                  className={classes.button}
                  onClick={(e) => {
                    e.stopPropagation();
                    let declaration_id = props.original.action_id;
                    let body = {
                      declaration_id,
                      request_delete: "reject",
                    };
                    let data = JSON.parse(localStorage.getItem("BerPay_Admin"));
                    let config = {};
                    if (data) {
                      config = {
                        headers: { Authorization: `Bearer ${data.token}` },
                      };
                    }
                    axios
                      .put(`${domain}/declaration/update`, body, config)
                      .then((res) => {
                        if (
                          res.data.statusCode === 200 ||
                          res.data.statusCode === 201
                        ) {
                          toastr.success(
                            "Declaration Request Rejected Successfully!"
                          );
                          setTimeout(() => {
                            window.location.reload();
                          }, 2000);
                        } else if (res.data.statusCode === 401) {
                          localStorage.removeItem("BerPay_Admin");
                          this.props.history.push("/admin/pages/login-page");
                        }
                      })
                      .catch((error) => {});
                  }}
                >
                  <Icon>clear</Icon>
                </IconButton>
              </Tooltip>
            </div>
          );
        },
      },
      {
        Header: "Profile Pic",
        Cell: (props) => {
          if (
            props &&
            props.original &&
            props.original.user &&
            props.original.user.profile_pic
          ) {
            return (
              <span>
                <img
                  className={
                    props.original.user.profile_pic ? "profile_pic" : null
                  }
                  src={props.original.user.profile_pic}
                ></img>
              </span>
            );
          } else return <span></span>;
        },
      },
      {
        Header: "Declaration Name",
        width: 150,
        accessor: "declarations.name",
      },
      {
        Header: "Travel Date/Time",
        width: 150,
        accessor: "declarations.travel_date",
        Cell: (props) => {
          return (
            props.original &&
            moment(
              props.original.declarations &&
                props.original.declarations.travel_date
            ).format("DD MMM YYYY, h:mm a")
          );
        },
      },
      {
        Header: "Username",
        accessor: "user.user_name",
      },
      {
        Header: "Prefix",
        accessor: "user.prefix",
      },
      {
        Header: "First Name",
        accessor: "user.first_name",
      },
      {
        Header: "Middle Name",
        width: 120,
        accessor: "user.middle_name",
      },
      {
        Header: "Last Name",
        accessor: "user.last_name",
      },
      {
        Header: "Suffix",
        accessor: "user.suffix",
      },
    ];
    return column;
  };

  render() {
    const { classes } = this.props;
    const { paidDeclaration } = this.state;
    return (
      <div>
        <GridContainer>
          <GridItem xs={12}>
            <Card>
              <CardBody>
                {/* <TextField
                  id="standard-search"
                  label="Search Flight by name"
                  name="search_event"
                  type="search"
                  fullWidth
                  value={search_event}
                  onChange={(event) => {
                    const { value } = event.target;
                    this.setState(
                      {
                        flightData: data,
                      },
                      () => {
                        const newwebinarData = this.state.flightData.filter(
                          (item) =>
                            item.name
                              .toLowerCase()
                              .includes(value.toLowerCase())
                        );
                        this.setState({
                          flightData: newwebinarData,
                          search_event: value.toLowerCase(),
                        });
                      }
                    );
                  }}
                  margin="normal"
                /> */}
                <ReactTable
                  data={paidDeclaration ? paidDeclaration : []}
                  columns={this.getPaymentTableColumn()}
                  defaultPageSize={20}
                  pageSizeOptions={[5, 10, 20, 25, 50]}
                  showPaginationBottom={true}
                  minRows={4}
                  // manual
                  noDataText="No Paid Declaration found"
                  onPageChange={(pageIndex) => {
                    console.log(pageIndex);
                    // let newQuery = getUserQuery;
                    // newQuery["offset"] = pageIndex * newQuery.limit;
                    // updateQueries(newQuery);
                    // getUserData(newQuery);
                  }}
                  onPageSizeChange={(rowPerPage) => {
                    console.log(rowPerPage);
                    // let newQuery = getUserQuery;
                    // newQuery["limit"] = rowPerPage;
                    // updateQueries(newQuery);
                    // getUserData(newQuery);
                  }}
                  // getTrProps={(state, rowInfo, column, instance) => {
                  //   return {
                  //     onClick: (e, handleOriginal) => {
                  //       if (rowInfo) {
                  //         // this.editCategoryFunc(rowInfo.original)
                  //       }
                  //     },
                  //     // style: {
                  //     //   cursor: 'pointer',
                  //     //   background: rowInfo && rowInfo.viewIndex%2 === 0 ? '#f9eddb' : '#e0d2be'
                  //     // }
                  //   };
                  // }}
                />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>

        {/* <DeleteModel
          showModel={showreject}
          title={"Are you sure you want to delete this Flight?"}
          onCancel={() => {
            this.setState({
              showreject: false,
              id: null,
            });
          }}
          onOk={() => {
            let id = this.state.id;
            // let body = {
            //   id: id
            // };
            axios
              .delete(`${domain}/setting/flight/${id}`, config)
              .then((res) => {
                if (res.data.statusCode === 200 || res.data.statusCode === 201) {
                  toastr.success("Flight Deleted Successfully!");
                  this.setState({
                    showreject: false
                  })
                  setTimeout(function () {
                    window.location.reload();
                  }, 2000);
                }
              })
              .catch((error) => { });
          }}
        /> */}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    // users: state.products.categories
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCustomerData: () => dispatch(getCustomerData()),
    // fetchCategories: ()=> dispatch(fetchCategories()),
    // categoryFormContent: (obj) => {dispatch({ type: PRODUCT_CATEGORY_ACTION.OPEN_CATEGORY_FORM, payload: obj })},
    // editCategory: (obj) => dispatch(editCategory(obj)),
    // deleteCategory: (obj,callback) => dispatch(deleteCategory(obj,callback)),
  };
};

const ManageCustumersComponent = withStyles(extendedTablesStyle)(
  ManagePaidDeclaration
);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageCustumersComponent);
